import { render, staticRenderFns } from "./taxType.vue?vue&type=template&id=bac2952c"
import script from "./taxType.vue?vue&type=script&lang=js"
export * from "./taxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports